import styled, { css } from 'styled-components';

import { COLORS, MOBILE } from '../../theme/tokens';
import { thinScrollbar } from '../../theme/mixins';
import { Text } from '../Text/Text';

export type TableAlign = 'left' | 'right';

/** Scroll container: on narrow viewports the table keeps a legible min width and pans. */
export const Wrap = styled.div`
  width: 100%;
  overflow-x: auto;
  ${thinScrollbar}
`;

export const Root = styled.table`
  width: 100%;
  border-collapse: collapse;

  /* Panels clip their own rounding; the last row's hairline would double the panel edge. */
  tbody tr:last-child td {
    border-bottom: none;
  }

  ${MOBILE} {
    min-width: 640px;
  }
`;

export const HeadCell = styled.th<{ $align: TableAlign; $width?: string }>`
  padding: 6px 12px 12px;
  text-align: ${(p) => p.$align};
  border-bottom: 1px solid ${COLORS.hairline};
  ${(p) => (p.$width ? `width: ${p.$width};` : '')}
`;

export const HeadLabel = styled(Text)`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${COLORS.textMuted};
  white-space: nowrap;
`;

export const Row = styled.tr<{ $clickable: boolean }>`
  ${(p) =>
    p.$clickable
      ? css`
          cursor: pointer;
          &:hover td,
          &:focus-visible td {
            background: ${COLORS.surfaceFaint};
          }
          &:focus-visible {
            outline: 1px solid ${COLORS.hoverBorderLit};
            outline-offset: -1px;
          }
        `
      : ''}
`;

export const Cell = styled.td<{ $align: TableAlign }>`
  padding: 14px 12px;
  text-align: ${(p) => p.$align};
  font-size: 14px;
  color: ${COLORS.text};
  border-bottom: 1px solid ${COLORS.hairline};
  vertical-align: middle;
`;
